import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';

export const StyledWatchlistPage = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
`;

export const TabContentWrapper = styled.div`
  width: ${scaleSize(1135)}px;
  height: ${scaleSize(1080)}px;
  margin: ${scaleSize(65)}px 0 0 ${scaleSize(95)}px;
  position: relative;
  white-space: normal;
`;
